import { ContentStateInterface } from '../../../../../../@types/types'
import { RealEstateAddress } from '../../../../../../@types/real-estate-api-types'
import {
  cutToChosenDigitLength,
  removeExtraWhitespaces,
  removeExtraWhitespacesWithoutUndefined,
} from '../../../../../../services/conversion/conversionServices'
import { AddressFeatureState } from '../../../../../../@types/state-types'
import { manualToApi } from './manual/manualToApi'
import { geoCoordinatesToApi } from './geoCoordinates/geoCoordinatesToApi'
import invariant from '../../../../../../utils/invariant'

export const addressToApi = (
  insertionData: ContentStateInterface,
  addressFeature: AddressFeatureState
): RealEstateAddress => {
  invariant(insertionData.city, 'City should not be undefined')
  const result = {
    street: removeExtraWhitespaces(insertionData.street),
    number: removeExtraWhitespaces(insertionData.houseNumber),
    city: removeExtraWhitespacesWithoutUndefined(insertionData.city),
    quarter: insertionData.quarter,
    hideStreetAndStreetNumber: insertionData.hideStreetAndStreetNumber ?? false,
    addressEditable: insertionData.addressEditable ?? true,
    ...manualToApi(addressFeature, insertionData),
  }
  if (insertionData.manualCountry?.value) {
    //International
    return {
      ...result,
      id: '',
      postcode: removeExtraWhitespaces(insertionData.postcode),
    }
  } else {
    //National
    return {
      ...result,
      id: insertionData.addressId,
      postcode: cutToChosenDigitLength(insertionData.postcode, 5),
      geoCoordinates: geoCoordinatesToApi(addressFeature, insertionData),
    }
  }
}
